import { __assign } from "tslib";
import { createMacrosApi } from '.';
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder } from '../test-utils';
export var createMacrosApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createMacrosApi('', fakeHttp);
    var macrosRelativePath = '/macros';
    var macrosUriUrl = function (id) { return "".concat(macrosRelativePath, "/").concat(id); };
    var testKit = {
        whenAddMacro: function (dto) { return createFakePostResponder(fakeHttp, macrosRelativePath)(dto); },
        whenUpdateMacro: function (dto) { return createFakePutResponder(fakeHttp, macrosUriUrl(dto.id))(dto); },
        whenGetMacro: function (id) { return createFakeGetResponder(fakeHttp, macrosUriUrl(id)); },
        whenGetAll: function () { return createFakeGetResponder(fakeHttp, "".concat(macrosRelativePath, "/admin")); },
        whenGetAllEnabled: function () { return createFakeGetResponder(fakeHttp, macrosRelativePath); },
        whenEnableMacro: function (id) { return createFakePostResponder(fakeHttp, "".concat(macrosRelativePath, "/enable"))({ id: id }); },
        whenDisableMacro: function (id) { return createFakePostResponder(fakeHttp, "".concat(macrosRelativePath, "/disable"))({ id: id }); },
        whenDeleteMacro: function (id) { return createFakePostResponder(fakeHttp, macrosRelativePath)({ id: id }); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map